export default "__VITE_ASSET__D43FzS8K__"